//Loads only those fees for the current logged in portal user
define(function() {
	const IpsModel = require('civicsBase/ipsModel');
	const urlBuilder = require('civicsUtils/buildUrlParameters');

	return IpsModel.extend({
		unpaidOnly:false,
		urlRoot: 'delegate/civics-api/api/portal/cdr/fees/total/',
		url:function(){
			var ret = this.urlRoot;
			if(this.unpaidOnly){
				var parms = urlBuilder.buildUrlParameters({
					filter:{
						property:'status',
						value:'U,I',
						operator:'In'
					},
					page:{
						max:0,
						start:1
					}
				});
				ret+=parms;
			}
			else if( this.urlParameters){
				ret += urlBuilder.buildUrlParameters(this.urlParameters)
			}
			return ret;
		},
	});
});
